import React from 'react'
import { Row, Col, Pagination, Offcanvas, Card } from 'react-bootstrap'
import { CiCircleCheck } from 'react-icons/ci'
import { FaCloudDownloadAlt, FaPlus, FaRegFileExcel } from 'react-icons/fa'

const MisDetails = () => {
    return (
        <>
            <div className="momDetails_inner">

                <Row>
                    <Col md={8} lg={8}>
                        <h2 className='font_blue_18 font-600 mb-3'>Mis Details</h2>

                        <Card className="MoM_Details">
                            <Card.Body>
                                <h3 className='font_blue_18 font-500 mb-3'>SmartSync feature launch</h3>
                                <ul className='feature_launch'>
                                    <li className="d-flex align-items-center">
                                        <img src="/images/Calendarb.svg" className='img-fluid me-2' alt="image" />
                                        <p className='font_blue_16 '>Mon, 21 Jan 2025</p>
                                    </li>
                                    <li className="d-flex align-items-center">
                                        <img src="/images/MapPointb.svg" className='img-fluid me-2' alt="image" />
                                        <p className='font_blue_16 '>Skye Corporate Park, 105, Shalimar Township, (M.P), Indore, 452010</p>
                                    </li>
                                    <li className="d-flex align-items-center">
                                        <span className='font_blue_16 pe-3 border-end'><img src="/images/worldb.svg" className='img-fluid me-2' alt="image" /> West Region</span>
                                        <span className='font_blue_16 ps-3'><img src="/images/Historyb.svg" className='img-fluid me-2' alt="image" /> 60 Min</span>
                                    </li>
                                </ul>

                                <div className="status d-flex align-items-center gap-2 py-3">
                                    <h4 className='font_blue_16 font-500'>Status:</h4>
                                    <span>Pending Follow Up </span>
                                </div>

                                <p className='font_blue_16 line-height26 pb-3'>
                                    A virtual meeting on web development brings together developers, designers, and stakeholders to
                                    discuss website or web app projects, trends, and technical challenges. These meetings, conducted
                                    via platforms like Zoom or Google Meet, often cover topics such as UI/UX design, coding best practices,
                                    frameworks, security, and performance optimization. They enable real-time collaboration, code reviews, and
                                    troubleshooting, fostering team efficiency in a remote setting.
                                </p>

                                <div className="d-flex align-items-center  gap-2 pb-3">
                                    <h4 className='font_blue_16 font-500'>Relationship Manager:</h4>
                                    <span className='font_blue_16 '>Kane Williamson (Senior RM) </span>
                                </div>

                                <div className=" pb-3">
                                    <h4 className='font_blue_16 font-500 mb-2'>Products</h4>
                                    <p className='font_blue_16 '>PMS Strategies (Portfolio Management Services) </p>
                                </div>

                                <div className=" pb-3">
                                    <h4 className='font_blue_16 font-500 mb-2'>Sub-Products</h4>
                                    <ul className='d-flex flex-column gap-2 sp_list'>
                                        <li className='font_blue_16 '><CiCircleCheck className='me-1' /> AAA India Opportunity Plan</li>
                                        <li className='font_blue_16 '><CiCircleCheck className='me-1' /> AAA Budding Beasts</li>
                                        <li className='font_blue_16 '><CiCircleCheck className='me-1' /> AAA Couture</li>
                                    </ul>
                                </div>

                                <div className="d-flex align-items-center  gap-2 pb-3">
                                    <h4 className='font_blue_16 font-500'>Channel Partners:</h4>
                                    <div class="d-flex align-items-center light_grey">
                                        <img class="img-fluid me-2" alt="SmartSync feature launch..." src="/images/cp_logo1.png" />
                                        <p>Humour Hive (Banks)</p>
                                    </div>
                                </div>

                                <div className="d-flex  flex-column  gap-2 pb-3 atte_doc">
                                    <h4 className='font_blue_16 font-500 mb-2'>Attached Document</h4>
                                    <div class="doc_file">
                                        <FaRegFileExcel className='me-2' />
                                        <span>Doc.file</span>
                                    </div>
                                </div>

                                <div className='member_list_sec'>
                                    <h4 className='font_blue_16 font-500 mb-2'>Members (5)</h4>

                                    <ul className='mamber_list'>
                                        <li>
                                            <ul className='d-flex align-items-center'>
                                                <li className='sr_n font_blue_14'>1</li>
                                                <li className='user'>
                                                    <div class="d-flex align-items-center">
                                                        <img class="img-fluid me-2" alt="image" src="/images/mamber_user.png" />
                                                        <p className='font_blue_14'>Guy Hawkins</p>
                                                    </div>
                                                </li>
                                                <li className='designation font_blue_14'>Designation</li>
                                            </ul>
                                        </li>
                                        <li >
                                            <ul className='d-flex align-items-center'>
                                                <li className='sr_n font_blue_14'>1</li>
                                                <li className='user'>
                                                    <div class="d-flex align-items-center">
                                                        <img class="img-fluid me-2" alt="image" src="/images/mamber_user.png" />
                                                        <p className='font_blue_14'>Guy Hawkins</p>
                                                    </div>
                                                </li>
                                                <li className='designation font_blue_14'>Designation</li>
                                            </ul>
                                        </li>
                                        <li >
                                            <ul className='d-flex align-items-center'>
                                                <li className='sr_n font_blue_14'>1</li>
                                                <li className='user'>
                                                    <div class="d-flex align-items-center">
                                                        <img class="img-fluid me-2" alt="image" src="/images/mamber_user.png" />
                                                        <p className='font_blue_14'>Guy Hawkins</p>
                                                    </div>
                                                </li>
                                                <li className='designation font_blue_14'>Designation</li>
                                            </ul>
                                        </li>
                                        <li >
                                            <ul className='d-flex align-items-center'>
                                                <li className='sr_n font_blue_14'>1</li>
                                                <li className='user'>
                                                    <div class="d-flex align-items-center">
                                                        <img class="img-fluid me-2" alt="image" src="/images/mamber_user.png" />
                                                        <p className='font_blue_14'>Guy Hawkins</p>
                                                    </div>
                                                </li>
                                                <li className='designation font_blue_14'>Designation</li>
                                            </ul>
                                        </li>
                                        <li >
                                            <ul className='d-flex align-items-center'>
                                                <li className='sr_n font_blue_14'>1</li>
                                                <li className='user'>
                                                    <div class="d-flex align-items-center">
                                                        <img class="img-fluid me-2" alt="image" src="/images/mamber_user.png" />
                                                        <p className='font_blue_14'>Guy Hawkins</p>
                                                    </div>
                                                </li>
                                                <li className='designation font_blue_14'>Designation</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>





                            </Card.Body>
                            <Card.Footer className='d-flex justify-content-end'>
                                <button className='btn blue_border d-flex align-items-center'><FaCloudDownloadAlt className='me-2' /> Download</button>
                            </Card.Footer>
                        </Card>
                    </Col>
                    <Col md={4} lg={4}>
                        <h2 className='font_blue_18 font-600 mb-3 '>Action Points</h2>

                        <Card className="MoM_Details Action_points">
                            <Card.Body>
                                <ol className='list-group-numbered'>
                                    <li className='font_blue1_16'>
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    </li>
                                    <li className='font_blue1_16'>
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    </li>
                                    <li className='font_blue1_16'>
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    </li>
                                </ol>

                                <div className=" py-3">
                                    <h4 className='font_blue_16 font-500 mb-2'>Next Follow Up: </h4>
                                    <p className='font_blue_16 '>Mon, 06 Feb 2025 at 12:30 PM</p>
                                </div>

                                <div className=''>
                                    <button className="btn red_button d-flex align-items-center" >
                                        <FaPlus className="me-1" /> Add Follow Up
                                    </button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </div>
        </>
    )
}

export default MisDetails